import { StaticBaseDao } from '@/dao';
import { SwapContestantRequest, IntArray } from '@/objects/generated';

export class StartnumberDao extends StaticBaseDao {
    public static async SwitchContestantsBib(eventId: number, request: SwapContestantRequest): Promise<IntArray | null> {
        return this.BaseFetch(
            IntArray,
            `Startnumber/SwitchContestantsBib` + '?' + (eventId == undefined ? '' : `eventId=${eventId}`),
            'POST',
            request,
        );
    }
    public static async SwitchContestantsChip(eventId: number, request: SwapContestantRequest): Promise<IntArray | null> {
        return this.BaseFetch(
            IntArray,
            `Startnumber/SwitchContestantsChip` + '?' + (eventId == undefined ? '' : `eventId=${eventId}`),
            'POST',
            request,
        );
    }
}
